import { IRegistration, IRegistrationStore } from "@model/Authentication.model";
import { RootState } from "../Store/Store";
import { useDispatch, useSelector } from "react-redux";
import { verifyUserAction } from "./VerifyAccountAction";
import { clearVerificationDataAction } from "./ClearVerificationDataAction";
import { useCallback } from "react";

const userRegistrationSelector = (state: RootState) =>
  state.userRegistrationReducer;

export const UserRegistrationStoreImplementation =
  (): IRegistrationStore | null => {
    const dispatch = useDispatch();
    const registrationCycle = useSelector<RootState, IRegistration | null>(
      userRegistrationSelector
    );

    const verifyUser = useCallback(
      (state: IRegistration) => verifyUserAction(state)(dispatch),
      [dispatch]
    );

    const clearVerificationData = useCallback(
      () => clearVerificationDataAction()(dispatch),
      [dispatch]
    );

    return {
      registrationState: registrationCycle || null,
      verifyUser,
      clearVerificationData,
    };
  };
